import { render, staticRenderFns } from "./RenderChildrensDocuments.vue?vue&type=template&id=78364597&"
import script from "./RenderChildrensDocuments.vue?vue&type=script&lang=js&"
export * from "./RenderChildrensDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78364597')) {
      api.createRecord('78364597', component.options)
    } else {
      api.reload('78364597', component.options)
    }
    module.hot.accept("./RenderChildrensDocuments.vue?vue&type=template&id=78364597&", function () {
      api.rerender('78364597', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/traceability/RenderChildrensDocuments.vue"
export default component.exports